import './DividendHistoryWidget.css';
import { BaseWidgetProps, WidgetHeightMessage } from '../../types/common.type';
import useDividendData from '../../hooks/data/useDividendData';
import DividendOverview from './components/DividendOverview';
import DividendChart from './components/DividendChart';
import DividendTable from './components/DividendTable';
import { useEffect, useRef } from 'react';
import useResizeNotifier from '../../hooks/useResizeNotifier';
import {
  ThemeType,
  WidgetMessageType,
  WidgetNameSource,
} from '../../utils/type';
import Layout from '../../Components/Common/Layout/Layout';
import Loading from '../../Components/Loading/Loading';
import ErrorMessage from '../../Components/ErrorMessage/ErrorMessage';
import { errorMsg } from '../../constants/common.constant';

export interface DividendHistoryWidgetProps extends BaseWidgetProps {
  token?: string;
  symbol?: string;
  onHeightChange?: (message: WidgetHeightMessage) => void;
}

export default function DividendHistoryWidget(
  props: DividendHistoryWidgetProps,
) {
  const {
    token,
    symbol,
    theme = ThemeType.Direct,
    onHeightChange,
    onError,
    onNoData,
    onLoadingChange,
  } = props;
  const { data, isLoading, error } = useDividendData(
    symbol,
    token,
    onError,
    onNoData,
  );
  const containerRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    onLoadingChange?.(isLoading);
  }, [isLoading]); // eslint-disable-line react-hooks/exhaustive-deps
  useResizeNotifier(
    containerRef,
    WidgetNameSource.DividendHistory,
    onHeightChange,
  );

  const msgItem = errorMsg.find((obj) => obj.key === 'dividends');

  return (
    <Layout theme={theme}>
      <div className="dividend-container" ref={containerRef}>
        {isLoading && !onLoadingChange ? (
          <Loading />
        ) : !isLoading && Boolean(error) ? (
          <ErrorMessage msg={msgItem} />
        ) : (
          <>
            <DividendOverview data={data!} />
            <DividendChart data={data!} theme={theme} />
            <DividendTable data={data!} />
          </>
        )}
      </div>
    </Layout>
  );
}
